"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processLocation = exports.getUserPosition = exports.geoLocate = exports.reverseLocate = exports.getForwardUrl = exports.getReverseUrl = exports.geo = exports.DEFAULT_LOCATE_OPTIONS = exports.DEFAULT_OPTIONS = exports.MAPBOX_API_KEY = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _get3 = _interopRequireDefault(require("lodash/get"));

var _geocoding = _interopRequireDefault(require("mapbox/lib/services/geocoding"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MAPBOX_API_KEY = 'pk.eyJ1IjoiZnJpa2ludGVjaCIsImEiOiJjazBmZXVzMGwwMTZ1M2RtN3Vndmp0ZmRtIn0.rAXvBHFJui8pC99lAgu5NQ';
exports.MAPBOX_API_KEY = MAPBOX_API_KEY;
var GeoClient = new _geocoding.default(MAPBOX_API_KEY);

var DEFAULT_OPTIONS = {
  autoComplete: false,
  country: 'US',
  fuzzyMatch: true,
  types: ['postcode']
},
    DEFAULT_LOCATE_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 30000,
  maximumAge: 0
},
    geo = {
  forward: function forward(locString) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!locString) return null;
    return GeoClient.geocodeForward(locString, _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options)).then(function (res) {
      return (0, _get3.default)(res, 'entity.features', []);
    }).catch(function (err) {
      return console.log('!!! error', err);
    });
  }
},
    getReverseUrl = function getReverseUrl(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude;
  return "https://api.mapbox.com/geocoding/v5/mapbox.places/".concat(longitude, ",").concat(latitude, ".json");
},
    getForwardUrl = function getForwardUrl(searchString) {
  return "https://api.mapbox.com/geocoding/v5/mapbox.places/".concat(searchString, ".json");
},
    reverseLocate = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2, params) {
    var latitude, longitude;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            latitude = _ref2.latitude, longitude = _ref2.longitude;
            params = _objectSpread({
              access_token: MAPBOX_API_KEY,
              types: ['postcode', 'place', 'region']
            }, params);
            return _context.abrupt("return", _axios.default.get(getReverseUrl({
              longitude: longitude,
              latitude: latitude
            }), {
              params: params
            }).then(function (_ref4) {
              var data = _ref4.data;
              return processLocation(data);
            }).catch(function () {}));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function reverseLocate(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}(),
    geoLocate = function geoLocate(options) {
  return new Promise(function (resolve, reject) {
    return navigator.geolocation.getCurrentPosition(resolve, reject, _objectSpread(_objectSpread({}, DEFAULT_LOCATE_OPTIONS), options));
  });
},
    getUserPosition = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var options,
        params,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            params = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            return _context2.abrupt("return", geoLocate(options).then(function (pos) {
              return reverseLocate(pos.coords, params);
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getUserPosition() {
    return _ref5.apply(this, arguments);
  };
}(),
    processLocation = function processLocation(loc) {
  var postcode = (0, _get3.default)(loc, 'features[0]', {}),
      place = (0, _get3.default)(loc, 'features[1]', {}),
      region = (0, _get3.default)(loc, 'features[2]', {}),
      zipCode = postcode.text,
      city = place.text,
      state = region.text,
      _get = (0, _get3.default)(postcode, 'center', {}),
      _get2 = _slicedToArray(_get, 2),
      latitude = _get2[0],
      longitude = _get2[1],
      userLocation = {
    zipCode: zipCode,
    city: city,
    state: state,
    latitude: latitude,
    longitude: longitude,
    geoCoded: true
  };

  return userLocation;
};

exports.processLocation = processLocation;
exports.getUserPosition = getUserPosition;
exports.geoLocate = geoLocate;
exports.reverseLocate = reverseLocate;
exports.getForwardUrl = getForwardUrl;
exports.getReverseUrl = getReverseUrl;
exports.geo = geo;
exports.DEFAULT_LOCATE_OPTIONS = DEFAULT_LOCATE_OPTIONS;
exports.DEFAULT_OPTIONS = DEFAULT_OPTIONS;